/**
 * 世锦赛日程 / 训练分组 PDF（官网写死，新文件往前插）
 */
export const BC_SCHEDULE_DOCS = [
  {
    id: 'c08-competition-schedule',
    titleKey: '官网资料C08比赛日程',
    fileName: 'C08_Competition_Schedule.pdf',
    url:
      'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1793070246515-52/C08_Competition_Schedule.pdf.pdf',
  },
  {
    id: 'training-20261101',
    titleKey: '官网资料训练分组1101',
    fileName: 'T&T_2026_WCH_Nanjing_training_groups_schedule_vs_20261101.pdf',
    url:
      'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1793070246515-50/T&T_2026%20_WCH_Nanjing_training%20groups_schedule_vs_20261101.pdf.pdf',
  },
  {
    id: 'competition-20261013',
    titleKey: '官网资料比赛日程1013',
    fileName: 'T&T_2026_WCH_Nanjing_Competition_schedule_vs_20261013.pdf',
    url:
      'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1793070246515-48/T&T_2026_WCH_Nanjing_Competition_schedule_vs_20261013.pdf.pdf',
  },
  {
    id: 'training-20261020',
    titleKey: '官网资料训练分组1020',
    fileName: 'T&T_2026_WCH_Nanjing_training_groups_schedule_vs_20261020.pdf',
    url:
      'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1793070246515-46/T&T_2026_WCH_Nanjing_training_groups_schedule_vs_20261020.pdf.pdf',
  },
];



// WEBPACK FOOTER //
// ./src/page/mainindex/bcScheduleDocs.js